import { render, staticRenderFns } from "./ProcessParametersTable.vue?vue&type=template&id=0f6afbf1"
import script from "./ProcessParametersTable.vue?vue&type=script&lang=ts"
export * from "./ProcessParametersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports